<template>
  <div style='width:100%;height: 100%;background: #fcfeff;overflow: scroll' id="container">
  </div>
</template>

<script>
import echarts from 'echarts';
import Vue from 'vue';
import {EventBus} from "../../plugins/eventBus";

Vue.prototype.$echarts = echarts;
export default {
  name: 'UeSubcriberChart',
  components: {
  },
  data() {
    return {
      chartIns: [],
      timer: '',
      imsi:[],
      qryParams:{},
    };
  },
  mounted() {
    this.initChartUe();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    clearTimer(){
      if(this.timer){
        clearInterval(this.timer);
      }
    },
    queryData(qryParams) {
      this.clearTimer();
      this.qryParams = qryParams;
      this.quartzGetData();
      this.timer = setInterval(this.quartzGetData, this.qryParams.interval*1000);
    },
    quartzGetData(){
      const This = this;
      this.$axios.post('/lte/ems/eam/ue/subscribers', this.qryParams).then((response) => {
        if (response.status === 200) {
          let count = 1;
          response.data.forEach(item =>{
            const chartInstance = This.createChart(item, count);
            this.chartIns[count-1]=chartInstance;
            count ++;
          });
          echarts.connect(this.chartIns);
        } else {
          EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
        }
      });
    },
    createChart(item, index){
      const container = document.getElementById("container");
      const series=[], times=[], rsrp1Data = [],rsrp2Data = [],nrsrp1Data = [],nrsrp2Data = [],
        sinr1Data = [],sinr2Data = [],ulData = [],dlData = [];
      const $this = this;
      const title = {
        textAlign: 'center',
        text: item.imsi,
        textStyle: {
          fontSize: 14,
          fontWeight: 'normal'
        },
        bottom: '15',
        left: '50%'
      };
      item.dataList.forEach( i =>{
        times.push($this.longtoString(i.createTime));
        rsrp1Data.push(i.rsrp1);
        rsrp2Data.push(i.rsrp2);
        nrsrp1Data.push(i.nRsrp1);
        nrsrp2Data.push(i.nRsrp2);
        sinr1Data.push(i.sinr1);
        sinr2Data.push(i.sinr2);
        ulData.push(i.ulData);
        dlData.push(i.dlData);
      });
      series.push({
        name: $this.$t('UE.ue_rsrp1'),
        type: 'line',
        data: rsrp1Data,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_rsnp2'),
        type: 'line',
        data: rsrp2Data,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_nrsrp1'),
        type: 'line',
        data: nrsrp1Data,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_nrsnp2'),
        type: 'line',
        data: nrsrp2Data,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_sinr1'),
        type: 'line',
        data: sinr1Data,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_sinr2'),
        type: 'line',
        data: sinr2Data,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_ul_data'),
        type: 'line',
        data: ulData,
        connectNulls:true,
      },{
        name: $this.$t('UE.ue_dl_data'),
        type: 'line',
        data: dlData,
        connectNulls:true,
      });
      let legend = {
        type:'scroll',
        icon:'roundRect',
        data: [this.$t('UE.ue_rsrp1'),this.$t('UE.ue_rsnp2'),this.$t('UE.ue_nrsrp1'),this.$t('UE.ue_nrsnp2'),
          this.$t('UE.ue_sinr1'), this.$t('UE.ue_sinr2'), this.$t('UE.ue_ul_data'), this.$t('UE.ue_dl_data')],
      };
      if(index > 1){
        legend.show=false;
      }
      const option = {
        title: title,
        legend : legend,
        color:['#7079df', '#60acfc', '#23c2db', '#63d5b2', '#d4ec59', '#feb64d', '#fa816d', '#d15b7f'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          backgroundColor: 'rgba(245, 245, 245, 0.8)',
          padding: 10,
          textStyle: {
            color: '#000'
          },
          position: function (pos, params, el, elRect, size) {
            var obj = {top: 10};
            obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          extraCssText: 'width: auto',
          formatter: function(params){
            let text = [];
            text.push(params[0].name + '<br/>');
            params.forEach(param =>{
              if(param.data == null){
                return true;
              }
              let html;
              if(param.seriesName.indexOf("RSRP") > -1){
                html = param.seriesName + ': <b style="color: #17b0cc">'+param.data + ' dBm</b><br/>';
              }else if (param.seriesName.indexOf("SINR") > -1){
                html = param.seriesName + ': <b style="color: #5473cc">' + param.data + ' dB</b><br/>';
              }else{
                html = param.seriesName + ': <b style="color: #00cc00">' + param.data + ' Mbps</b><br/>';
              }
              text.push(html);
            });
            return text.join('');
          }
        },
        xAxis: {
          type: 'category',
          data: times,
          scale: true,
          boundaryGap : false,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
          }
        },
        series: series
      };
      let dom = document.getElementById("chartDiv"+index);
      let chartInstance;
      if(dom){
        chartInstance = this.$echarts.init(dom);
      }else{
        const echartNode = document.createElement('div');
        echartNode.style.marginTop="5px";
        echartNode.style.height="250px";
        echartNode.id="chartDiv"+index;
        container.appendChild(echartNode);
        chartInstance = this.$echarts.init(echartNode);
      }
      if(chartInstance.getOption() == undefined){
        const select ={};
        select[this.$t('UE.ue_sinr1')]=false;
        select[this.$t('UE.ue_sinr2')]=false;
        select[this.$t('UE.ue_ul_data')]=false;
        select[this.$t('UE.ue_dl_data')]=false;
        option.legend.selected=select;
      }
      chartInstance.setOption(option);
      return chartInstance;
    },

    initChartUe() {
      if(this.chartIns.length > 0){
        this.chartIns.forEach(item =>{
          item.clear();
        });
      }
      const container = document.getElementById("container");
      if(container && container.hasChildNodes()){
        container.childNodes.forEach(i=>{
          container.removeChild(i);
        })
      }
    },
    longtoString(longTypeDate) {
      let datetimeType = '';
      const date = new Date();
      date.setTime(longTypeDate);
      const hour = date.getHours().toString().padStart(2, '0');
      const min = date.getMinutes().toString().padStart(2,'0');
      const sec = date.getSeconds().toString().padStart(2,'0');
      datetimeType = `${hour}:${min}:${sec}`;
      return datetimeType;
    }
  }
};

</script>

<style scoped>

</style>
